export const attachDocs = {
    isOpen: false,
    loadingDocuments: false,
    loadingNotes: false,
    currentCaseRun: {},
    activeNotes: [],
    documentsAvailable: [],
    specialtiesDictionary: [],
    noteTypesDictionary: []
};
